/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createCFPBSettlementCase} from '../api'

export const useMutationCreateCFPBSettlementCase = createReactQueryMutationHook('createCFPBSettlementCase', createCFPBSettlementCase)
